import { useEffect } from 'react'
import { useGetSiteThemeQuery } from '../slices/userApiSlice'
import { applyTheme } from '../utils/theme'

function ThemeProvider({ children }) {
  const { data, isSuccess } = useGetSiteThemeQuery()

  useEffect(() => {
    if (!isSuccess || !data?.theme) return
    applyTheme(data.theme)
  }, [isSuccess, data?.theme])

  return children
}

export default ThemeProvider
